import { PhishingDemoRequest, PhishingDemoResponse, PromptSettings } from '../model/PhishingDemo';
import { fetchWithToken } from "./fetchWithToken";

const getBaseUrl = () => {
    let url;
    switch (process.env.NODE_ENV) {
        case 'production':
            url = '/api/system/phishing-demo';
            break;
        case 'development':
            url = 'http://localhost:5000/api/system/phishing-demo';
            break;
        default:
            url = '/api/system/phishing-demo';
    }
    return url;
};

export const generatePhishingMail = async (request: PhishingDemoRequest): Promise<Response> => {
    try {
        const response = await fetchWithToken(`${getBaseUrl()}/generate`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(request),
        });
        return response;
    } catch (error) {
        throw new Error("Error generating phishing mail");
    }
};

export const updatePromptSettings = async (settings: PromptSettings): Promise<Response> => {
    try {
        const response = await fetchWithToken(`${getBaseUrl()}/prompts`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(settings),
        });
        return response;
    } catch (error) {
        throw new Error("Error updating prompt settings");
    }
};

export const getPromptSettings = async (): Promise<Response> => {
    try {
        const response = await fetchWithToken(`${getBaseUrl()}/prompts`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response;
    } catch (error) {
        throw new Error("Error loading prompt settings");
    }
};

export const sendPhishingMail = async (subject: string, body: string, mailAddress: string): Promise<Response> => {
    try {
        const response = await fetchWithToken(`${getBaseUrl()}/send`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                subject,
                body,
                mailAddress
            }),
        });
        return response;
    } catch (error) {
        throw new Error("Error sending phishing mail");
    }
}; 